import { inject } from "vue";
import { useListingArrayModel } from "./useListingArrayModel";
import { transformOfferedServicesToApi } from "../utils/transformers/servicesTransformers";
import type { OfferedService } from "../types/listingModels";
import { ListingOfferedServicesStoreKey } from "./listingStoreKeys";

export function createListingOfferedServicesStore() {
    const arrayModel = useListingArrayModel<OfferedService>();

    function getPublishable() {
        return transformOfferedServicesToApi(arrayModel.model.value);
    }

    return {
        model: arrayModel.model,
        initial: arrayModel.initial,
        isDirty: arrayModel.isDirty,
        add: arrayModel.add,
        updateAt: arrayModel.updateAt,
        removeAt: arrayModel.removeAt,
        markSaved: arrayModel.markSaved,
        resetAll: arrayModel.resetAll,
        getPublishable,
    };
}

export function useListingOfferedServicesStore() {
    const store = inject(ListingOfferedServicesStoreKey);
    if (!store) {
        throw new Error('useListingOfferedServicesStore must be used within a component that provides ListingOfferedServicesStoreKey');
    }
    return store;
}

